import { WHMCS_URL } from '@/config/';

export const MANAGE_USERS_URL = `${WHMCS_URL}/clientarea.php?action=contacts`;
